import script from "./SettingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsView.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsView.vue?vue&type=style&index=0&id=c179139c&scoped=true&lang=scss"

import exportComponent from "/home/deployer/pwa/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c179139c"]])

export default __exports__